<div class="field w-full">
  @if (label) {
  <label class="block mb-1">{{ label }}</label>
  }

  <div
    class="flex"
    [ngClass]="layout === 'vertical' ? 'flex-col gap-2' : 'flex-row gap-4 flex-wrap'"
  >
    @for(opt of options; track opt.label) {
    <div class="flex items-start">
      <p-checkbox
        class="checkbox-glow"
        [inputId]="opt[optionValue]"
        [value]="opt[optionValue]"
        [binary]="true"
        [disabled]="disabled"
        [ngModel]="isChecked(opt)"
        (onChange)="onToggle($event, opt)"
        [invalid]="ngControl.invalid && submitted"
      >
      </p-checkbox>

      <label [for]="opt[optionValue]" class="ml-2 {{ checkboxCustomClass }}">
        {{ opt[optionLabel] }}
      </label>
    </div>
    }
  </div>

  <small [appFormErrorMessageDirective]="ngControl.control" [submitted]="submitted"></small>
</div>
